import * as React from 'react';
import account from './svgs/account.svg';
import assess from './svgs/assess.svg';
import settings from './svgs/settings.svg';
import hamburger from './svgs/hamburger.svg';
import shield from './svgs/shield.svg';
import shieldOff from './svgs/shieldOff.svg';
import home from './svgs/home.svg';
import indentArrow from './svgs/indentArrow.svg';
import arrowRight from './svgs/arrowRight.svg';
import arrowRightThick from './svgs/arrowRightThick.svg';
import arrowBack from './svgs/arrowBack.svg';
import close from './svgs/close.svg';
import loading from './svgs/loading.svg';
import error from './svgs/error.svg';
import people from './svgs/people.svg';
import ip from './svgs/ip.svg';
import page from './svgs/page.svg';
import dropdownUp from './svgs/dropdown-up.svg';
import dropdownDown from './svgs/dropdown-down.svg';
import training from './svgs/training.svg';
import car from './svgs/car.svg';
import driver from './svgs/driver.svg';
import downArrow from './svgs/downArrow.svg';
import upArrow from './svgs/upArrow.svg';
import paper from './svgs/paper.svg';
import arrowNext from './svgs/arrowNext.svg';
import arrowPrev from './svgs/arrowPrev.svg';
import visa from './svgs/visa.svg';
import pdf from './svgs/pdf.svg';
import pdfDisabled from './svgs/pdfDisabled.svg';
import download from './svgs/download.svg';
import americanExpress from './svgs/amex.svg';
import bank from './svgs/bank.svg';
import mastercard from './svgs/mastercard.svg';
import discover from './svgs/discover.svg';
import diners from './svgs/diners.svg';
import filter from './svgs/filter.svg';
import chevronRight from './svgs/chevronRight.svg';
import info from './svgs/info.svg';
import infoFilled from './svgs/infoFilled.svg';
import checkboxFull from './svgs/checkboxFull.svg';
import check from './svgs/check.svg';
import lock from './svgs/lock.svg';
import gift from './svgs/gift.svg';
import ocho from './svgs/ocho.svg';
import cloudDownload from './svgs/cloudDownload.svg';
import openInNew from './svgs/openInNew.svg';
import signatureComplete from './svgs/signature-complete.svg';
import signatureIncomplete from './svgs/signature-incomplete.svg';
import reversed from './svgs/reversed.svg';
import outward from './svgs/outward.svg';
import playCircle from './svgs/playCircle.svg';
import lockOutlined from './svgs/lockOutlined.svg';
import swapHoriz from './svgs/swapHoriz.svg';
const variantMapping: {
  assess: React.ReactElement<unknown>;
  account: React.ReactElement<unknown>;
  settings: React.ReactElement<unknown>;
  hamburger: React.ReactElement<unknown>;
  shield: React.ReactElement<unknown>;
  shieldOff: React.ReactElement<unknown>;
  home: React.ReactElement<unknown>;
  indentArrow: React.ReactElement<unknown>;
  arrowRight: React.ReactElement<unknown>;
  arrowRightThick: React.ReactElement<unknown>;
  close: React.ReactElement<unknown>;
  loading: React.ReactElement<unknown>;
  download: React.ReactElement<unknown>;
  error: React.ReactElement<unknown>;
  people: React.ReactElement<unknown>;
  arrowBack: React.ReactElement<unknown>;
  ip: React.ReactElement<unknown>;
  page: React.ReactElement<unknown>;
  dropdownUp: React.ReactElement<unknown>;
  dropdownDown: React.ReactElement<unknown>;
  pdf: React.ReactElement<unknown>;
  pdfDisabled: React.ReactElement<unknown>;
  training: React.ReactElement<unknown>;
  car: React.ReactElement<unknown>;
  driver: React.ReactElement<unknown>;
  downArrow: React.ReactElement<unknown>;
  upArrow: React.ReactElement<unknown>;
  paper: React.ReactElement<unknown>;
  arrowNext: React.ReactElement<unknown>;
  arrowPrev: React.ReactElement<unknown>;
  visa: React.ReactElement<unknown>;
  americanExpress: React.ReactElement<unknown>;
  bank: React.ReactElement<unknown>;
  mastercard: React.ReactElement<unknown>;
  diners: React.ReactElement<unknown>;
  discover: React.ReactElement<unknown>;
  filter: React.ReactElement<unknown>;
  chevronRight: React.ReactElement<unknown>;
  info: React.ReactElement<unknown>;
  infoFilled: React.ReactElement<unknown>;
  checkboxFull: React.ReactElement<unknown>;
  check: React.ReactElement<unknown>;
  lock: React.ReactElement<unknown>;
  gift: React.ReactElement<unknown>;
  ocho: React.ReactElement<unknown>;
  cloudDownload: React.ReactElement<unknown>;
  openInNew: React.ReactElement<unknown>;
  signatureComplete: React.ReactElement<unknown>;
  signatureIncomplete: React.ReactElement<unknown>;
  reversed: React.ReactElement<unknown>;
  outward: React.ReactElement<unknown>;
  playCircle: React.ReactElement<unknown>;
  lockOutlined: React.ReactElement<unknown>;
  swapHoriz: React.ReactElement<unknown>;
} = {
  assess,
  account,
  settings,
  hamburger,
  shield,
  shieldOff,
  download,
  home,
  indentArrow,
  arrowRight,
  arrowRightThick,
  arrowBack,
  close,
  loading,
  error,
  people,
  ip,
  pdf,
  pdfDisabled,
  page,
  dropdownUp,
  dropdownDown,
  training,
  car,
  driver,
  downArrow,
  upArrow,
  paper,
  arrowNext,
  arrowPrev,
  visa,
  americanExpress,
  bank,
  mastercard,
  discover,
  filter,
  chevronRight,
  info,
  infoFilled,
  checkboxFull,
  check,
  diners,
  lock,
  gift,
  ocho,
  cloudDownload,
  openInNew,
  signatureComplete,
  signatureIncomplete,
  reversed,
  outward,
  playCircle,
  lockOutlined,
  swapHoriz,
};

export default variantMapping;
